/* eslint-disable max-statements */
import { isNull, isUndefined } from "lodash";
import { formatPointLabel } from "components/widgets/chart/base/utils";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
const getFormattedValue = (displayValueType, value, formatUnit) => {
    let options = {};
    if (displayValueType === ChartSelectValueFormatKind.compactAmount ||
        displayValueType === ChartSelectValueFormatKind.area ||
        displayValueType === ChartSelectValueFormatKind.unit) {
        options = { ...options, maximumFractionDigits: 2, minimumFractionDigits: 2 };
    }
    const moneyValue = value;
    const amount = moneyValue?.amount;
    if (!isUndefined(amount) && !isNull(amount)) {
        options = { ...options, currency: moneyValue.currency };
        return formatPointLabel(moneyValue.amount, displayValueType, "", options, formatUnit);
    }
    const areaValue = value;
    const area = areaValue?.area;
    if (!isUndefined(area) && !isNull(area)) {
        options = { ...options, unitOfArea: areaValue.unit };
        return formatPointLabel(areaValue.area, displayValueType, "", options, formatUnit);
    }
    const unitValue = value;
    const unit = unitValue?.unit;
    if (!isUndefined(unit) && !isNull(unit)) {
        options = { ...options, unitForValue: unitValue.unit };
        return formatPointLabel(unitValue.value, displayValueType, "", options, formatUnit);
    }
    return !isUndefined(value) && !isNull(value) ? formatPointLabel(value, displayValueType, "", options, formatUnit) : "-";
};
export const valuePair = (params) => (args) => {
    const element = args.visitable;
    const measures = element?.data ? element?.data[0].measures : element.measures;
    if ((args?.context?.staticData?.customResult?.length || 0) > 0) {
        return;
    }
    args.context.staticData.customResult = [];
    params.forEach((column) => {
        const fields = column.fields.map((field) => {
            const value = measures?.[field.id];
            const formattedValue = getFormattedValue(field.displayValueType, value, args.context.widgetState?.dataScale);
            return { href: field.href,
                icon: field.icon,
                image: field.image,
                isPipeless: field.isPipeless,
                size: field.size,
                title: field.title,
                type: field.type,
                value: formattedValue };
        });
        if (args.context.staticData.customResult) {
            args.context.staticData.customResult.push({
                fields
            });
        }
    });
};
